module.exports = __webpack_public_path__ + "img/suspend.640c4cf8.svg";